import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'//React routes
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { SupervisorAccountOutlined, PersonOutline } from '@mui/icons-material/';
import { TextField, IconButton, Slide, Typography, Card as CardCustom, Box as BoxCustom, styled, Grid } from '@mui/material';

import { UseImage, CustomLoadingOverlay, GenericContainer, CustomAlertHelpDialog, CustomAlertDialog, InputField, Buttons } from '../../components'
import { fileActions, addTitleLegoCurrent, documentsActions } from '../../store/actions';
import { GetMimeType, b64toUrl, coreFunctions } from '../../utils'
import noResultImg from '../../assets/noResult.png'
import UserGroupMasiveSign from '../documentSign/UserGroupMasiveSign';
import iconView from '../../assets/icons/iconView.png'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { fileMasiveActions } from '../../store/actions/FileMasiveActions';
import VisorPDF from '../../components/Visor/VisorPDF';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import RejectDocuments from '../documentSign/RejectDocument';


const Box = styled(BoxCustom)(({ theme }) => ({
    width: '100%',
    display: 'flex',
}));

const IconButtonCustom = styled(IconButton)(({ theme }) => ({
    height: '30px',
    width: '30px',
    '&:focus': {
        outline: 'none !important',
    },
}));


const BoxContainer = styled(Box)(({ theme }) => ({
    height: "auto",
    width: "100%",
    justifyContent: "space-between",
    marginTop: 5,
    marginBottom: 1,
    borderBottom: "1px solid #D9D9D9",
    display: "flex",
}));

const BoxTitulo = styled(Box)(({ theme }) => ({
    wordWrap: "break-word",
    width: "45%",
    [theme.breakpoints.down("sm")]: {
        width: "40%",
    },
}));

const BoxTexto = styled(Box)(({ theme }) => ({
    wordWrap: "break-word",
    textAlign: "right",
    justifyContent: 'right',
    width: "55%",
    [theme.breakpoints.down("sm")]: {
        width: "60%",
    },
}));


const TextFieldSearch = styled(TextField)(({ theme }) => ({
    "& .MuiOutlinedInput-input": {
        height: 25,
        padding: "10px 15px",
        [theme.breakpoints.down("sm")]: {
            height: 18,
            padding: "8px 10px",
        },
    },
    "& .MuiOutlinedInput-root": {
        borderRadius: 12,
        fontSize: 14,
        "& fieldset legend span": {
            display: "none",
        },
        [theme.breakpoints.down("sm")]: {
            // fontSize: '10px',
            // lineHeight: '144%',
            borderRadius: 2,
        },
    },
    "& .MuiInputLabel-root": {
        color: "#000",
        position: "relative",
        transform: "none",
        fontSize: "16px",
        marginBottom: 5,
        marginTop: 5,
        display: "flex",
        alignItems: "center",
        pointerEvents: "auto",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "140%",
        // fontFamily: '"Montserrat",sans-serif',
        [theme.breakpoints.down("sm")]: {
            fontWeight: 400,
            fontSize: "9px",
            lineHeight: "144%",
        },
    },
    "& label.Mui-focused": {
        color: theme.palette.primary.main,
    },
    "& label.Mui-error": {
        color: "#C20E30 !important",
        // #C20E30
    },
    "& .MuiSelect-select": {
        height: 25,
        "& .notranslate": {
            display: "block",
            margin: "2.45px 0",
        },
    },
    "& .MuiInputBase-multiline": {
        padding: "0",
    },
    input: {
        "&::placeholder": {
            [theme.breakpoints.down("sm")]: {
                fontWeight: 400,
                fontSize: "10px",
            },
        },
    },
}));

const Card = styled(CardCustom)(({ theme }) => ({
    border: `1px solid ${theme.palette.primary.color}`,
    margin: theme.spacing(1),
    '&:hover': {
        backgroundColor: theme.palette.secondary.contrastText
    },
    [theme.breakpoints.only('xs')]: {
        width: '100% !important',
    },
    [theme.breakpoints.only('sm')]: {
        width: '100% !important',
    },
    [theme.breakpoints.only('md')]: {
        width: '60% !important',
    },
    [theme.breakpoints.only('lg')]: {
        width: '60% !important',
    },
    [theme.breakpoints.only('xl')]: {
        width: '60% !important',
    },
}));

export default function SearchResultComponentMasive(props) {
    const navigate = useNavigate()
    const location = useLocation()
    const [loadView, setLoadView] = useState(false)
    const [openSearch, setOpenSearch] = useState(false)
    const [cardsData, setCardData] = useState([])
    const [search, setSearch] = useState('')
    const [selectSearchFile, setSelectSearchFile] = useState(false)
    const [documentsAcepted, setDocumentsAcepted] = useState([]);


    const files = useSelector(state => state.GetSignatureRequestsByUsuario)
    const file = useSelector((state) => state.FileInfo);
    const State = useSelector((state) => state);

    console.log('REDUX', State)
    console.log('documentsAcepted', documentsAcepted)

    const dispatch = useDispatch()

    const { t } = useTranslation();

    const handleClose = () => {
        setOpenSearch(false)
        setSearch('0')
    }

    useEffect(() => {
        dispatch(addTitleLegoCurrent(t("general_solicitud")))
    }, [])

    useEffect(() => {
        dispatch(fileMasiveActions.GetSignatureRequestsByUsuario({ Body: { "SearchText": search } }))
        //        dispatch(fileActions.GetFilesSearch({ "SearchText": search }))
    }, [search])

    useEffect(() => {
        if (location?.state?.forceReload) {
            dispatch(fileMasiveActions.GetSignatureRequestsByUsuario({ Body: { "SearchText": search } }))
        }
      }, [location?.state]);

    useEffect(() => {
        setLoadView(files.loading)
        if (files.items != undefined) {
            setCardData(files.items)
        }
        if (files.error != undefined) {
            alert(files.error)
        }
    }, [files])

    /* const getFolio = (id) => {
        dispatch(fileActions.GetFileInfo(id));
        setSelectSearchFile(true)
        setLoadView(true)
    } */

    /* useEffect(() => {
        if (file.items != undefined && selectSearchFile && file.items?.Stage != undefined) {
            setSelectSearchFile(false)
            let stageName = file.items.Stage.Name
            let stageId = file.items.Stage.Id
            let stage = file.items.Stage
            let folioId = file.items.Id
            let actorId = file.items.Stage.CurrentActor === null ? null : file.items.Stage.CurrentActor?.Id
            let nextComponent = "CanvasPdfSignComponent"
            // let nextComponent = coreFunctions.GetLegoNext(stageName)
            console.log('nextComponent', stageName)
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId, actorId } })
        }
    }, [file]) */

    let handleSignButton = () => {
        dispatch(fileMasiveActions.UploadBatchSign(null,true));
        const jsonString = JSON.stringify(documentsAcepted);
        sessionStorage.setItem('documentsAceptedData', jsonString)
        let nextStage = ""
        let stageName = ""
        let stageId = ""
        let folioId = ""
        let stage = ""
        let nextComponent = "CanvasPdfSignMasiveComponent"
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
    }

    /*  let handleSignButton = () => {
         let nextStage = file.items.Stage
         let stageName = nextStage.Name
         let stageId = nextStage.Id
         let folioId = file.items.Id
         let stage = file.items.Stage
         let nextComponent = "CanvasPdfSignMasiveComponent"
         coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
     }
  */

    return (<GenericContainer sx={{ width: '100% !important' }}>
        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
        <Box sx={{
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
        }}>
            {!openSearch ?
                <IconButtonCustom
                    edge={openSearch ? 'end' : ''}
                    color="inherit"
                    onClick={() => { setOpenSearch(true) }}
                    aria-label="search">
                    <SearchIcon />
                </IconButtonCustom>
                : <Slide direction="left" in={openSearch} mountOnEnter unmountOnExit>
                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                        <IconButtonCustom
                            edge="start"
                            color="inherit"
                            onClick={() => {
                                handleClose()
                            }}
                            aria-label="back">
                            <ArrowBackIcon />
                        </IconButtonCustom>
                        <TextFieldSearch type='text' fullWidth
                            placeholder={t("enter_search_criteria")}
                            value={search}
                            onChange={(e) => { setSearch(e.target.value) }}
                        />
                    </Box>
                </Slide>
            }
        </Box>

        <Box sx={{
            flexDirection: 'column',
            alignItems: 'center'
        }}>
            {/* <Typography variant="h6" gutterBottom>Solicitudes</Typography> */}
            {cardsData.length == 0
                ? <Box sx={{
                    height: '70vh',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <UseImage width={'40%'} src={noResultImg} />
                    <Typography variant="h6" gutterBottom>{t("no_results_found")}</Typography>
                </Box>
                : <Box sx={{
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                }}>
                    {cardsData.map((card) => {
                        return (
                            <CardDocuments Card={card} setDocumentsAcepted={setDocumentsAcepted} DocumentsAcepted={documentsAcepted} />
                        )
                    }
                    )}

                    <Buttons
                        disabledConfirm={documentsAcepted.length > 0 ? false : true}
                        ConfirmButtonText={t("legal_sign")}
                        onClickConfirm={handleSignButton}
                    />
                </Box>
            }
        </Box >


    </GenericContainer>)
}

const CardDocuments = (props) => {
    const { control, watch, setValue } = useForm({ mode: 'onBlur' });
    const dispatch = useDispatch();
    const checked = watch('aprobacionKit');

    const pdfDoc = useSelector((state) => state.Document)
    const [open, setOpen] = useState(false);
    const [fileUrl, setfileUrl] = useState(null);
    const [documentId, setDocumentId] = useState(0);

    const { t } = useTranslation();

    const customDocumentAproved = (pdfDoc) => {
        setfileUrl(null);
        dispatch(documentsActions.DownloadDocument(null, true));
        const existe = props.DocumentsAcepted.some(objeto => objeto.File_Id === props.Card.Id);
        setValue('aprobacionKit', existe)
        setOpen(!open);
        console.log('aprobacionKit', pdfDoc )
        let kitContratacion = pdfDoc.Stage.DocumentalCategory?.DocumentalGroups[0]?.DocumentTypes[0]?.Document.Id;
        setDocumentId(kitContratacion);
        dispatch(documentsActions.DownloadDocument(kitContratacion))
    }

    useEffect(() => {
        setValue('aprobacionKit 0')
        console.log("pdfDoc.items.............: ", pdfDoc.items)
        if (pdfDoc.items != undefined) {
            setfileUrl(null);
            let pdfB64 = pdfDoc.items.B64Content;
            if (pdfB64 != undefined && pdfB64 != null) {
                async function fetchData() {
                    const blobUrl = await b64toUrl(`${GetMimeType(".pdf")},${pdfB64}`)
                    setfileUrl(blobUrl);
                }
                fetchData()
            }
        }
    }, [pdfDoc]);

    const acceptedDocuments = () => {
        
        const existe = props.DocumentsAcepted.some(objeto => objeto.File_Id === props.Card.Id);
        console.log('checked', checked, existe)
        if (existe === false && checked == true) {
            const fechaActual = new Date();
            let newObject = {
                "File_Id": props.Card.Id,
                "ApprovedDate": fechaActual.toISOString()
            }
            props.setDocumentsAcepted([...props.DocumentsAcepted, newObject]); // Agregar el nuevo objeto al estado utilizando el operador spread
            setOpen(!open)
        } else if (checked == false && existe === true) {
            let arrayObjetos = props.DocumentsAcepted.filter(objeto => objeto.File_Id !== props.Card.Id);
            console.log('arrayObjetos', arrayObjetos)
            setOpen(!open)
        } else /* if(checked && existe) */{
            setOpen(!open)
        }
    };

    const handleCloseViewer = () => setOpen(false);

    return (
        <>
            <Card 
                id={`cardSigned_${props.Card.Id}`}   
                style={{ marginTop: '.7em', marginLeft: '.8em' }}
                onClick={() => {
                    console.log("Clickcard: ", props.Card.Id)
                    customDocumentAproved(props.Card)
                    // getFolio(props.Card.Id)
                }}>
                {
                    console.log("Clickprops.Card: ", props.Card)
                }
                <Box style={{ background: '#0060A2', color: 'white', display: "flex", alignItems: "center" }}>
                    <Box sx={{ display: 'flex', alignItems: "center", p: 1 }}>
                        {props.DocumentsAcepted.some(objeto => objeto.File_Id === props.Card.Id) === true ?
                            <UseImage src={iconView} style={{ height: 20, marginRight: 5 }} />
                            :
                            null
                        }
                        <Box sx={{ ml: 2 }}>
                            <Typography variant="subtitule" >
                                {t("folio_solicitud")}: {props.Card.Folio}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    p: 1
                }}>
                    <Statements title={`${t("general_name")}:`} text={props.Card.FullName} />
                    <Statements title={`${t("general_position_job")}:`} text={props.Card.Metadata.find((item) => item.Name === 'Puesto')?.Value ?? "NA"} />
                    <Statements title={`${t("general_identity")}:`} text={props.Card.Metadata.find((item) => item.Name === 'IdentificadorNacional')?.Value ?? "NA"} />
                    <Statements title={`${t("date_entry")}:`} text={props.Card.Metadata.find((item) => item.Name === 'FechaIngreso')?.Value ?? "NA"} />
                    <Statements title={`${t("date_signature_assignment")}:`} text={props.Card.Metadata.find((item) => item.Name === 'FechaAsignacionRepresentante')?.Value ?? "NA"} />
                    <Statements title={`${t("hiring_kit")}:`} text={<ArticleOutlinedIcon sx={{ color: "#A3D043" }} />} />
                </Box>
            </Card>
            <CustomAlertDialog
                open={open}
                title={t("hiring_kit")}
                textAcepted={t("confirm_sign")}
                aceptedAction={() => acceptedDocuments()}
                closeAction={() => setOpen(!open)}
                customControl={
                <RejectDocuments 
                    documentId={documentId}
                    fileId={props.Card.Id} 
                    height={38} 
                    handleCloseViewer={handleCloseViewer}
                />}
                Body={
                    <Grid container>
                        <Box>
                            <VisorPDF pdfUrl={fileUrl} />
                        </Box>
                        <Box>
                            <InputField
                                inputType="check"
                                control={control}
                                name={'aprobacionKit'}
                                label={t("legal_read_auth_sign")}
                            />
                        </Box>
                    </Grid>
                }
            />
        </>
    )

}

const Statements = (props) => {
    return (
        <BoxContainer>
            <BoxTitulo>
                <Typography variant="subtitle1" style={{ fontWeight: 500, padding: '.4em', margin: '0px' }}>
                    <b>
                        {props.title}
                    </b>
                </Typography>
            </BoxTitulo>
            <BoxTexto>
                <Typography variant="subtitle1" textAlign={"right"} style={{ padding: '.4em', margin: '0px' }}>
                    {props.text}
                </Typography>
            </BoxTexto>
        </BoxContainer>
    );
};